import axios from "src/lib/axios";

/**
 *
 * @param {object} data
 * @param {string} data.prompt - prompt text
 * @param {string} data.model - AI model name
 * @param {Base64URLString} data.image1Base64 - base64 string without prefix data:image/...;base64,
 * @param {string} data.image1Type - mime type
 * @param {Base64URLString} data.image2Base64 - base64 string without prefix data:image/...;base64,
 * @param {string} data.image2Type - mime type
 * @returns {Promise<object>} - response data
 */
export const generateContent = async ({
  prompt,
  model = "gemini-3-pro-image-preview",
  image1Base64,
  image1Type,
  image2Base64,
  image2Type,
  itemCode = null,
}) => {
  const { data: response } = await axios.post(`/nano-banana-base64`, {
    prompt,
    model,
    image1Base64,
    image1Type,
    image2Base64,
    image2Type,
    itemCode,
  });
  return response.data;
};

export const findAllSuggestArea = async () => {
  const { data: response } = await axios.get(`/suggest-area`);
  return response.data;
};
